<template>
    <div class="container p-5" style=" margin-top: 50px; margin-bottom: 80px">
        <div class="d-flex flex-row justify-content-between flex-wrap pb-1">
            <h2 class="text-bg">Editar proveedor</h2>
            <n-button type="info" size="medium" style="font-size: 20px" @click="$router.back()">
                <i class="icon-arrow-left" style="padding-right: 12px;"></i>
                REGRESAR
            </n-button>
        </div>
        <n-form size="large" label-placement="top" :rules="rules" ref="formRef" :model="model">
            <div class="mt-5 mb-3">
                <n-form-item label="Nombre" path="name">
                <n-input type="text" id="inputName" v-model:value="model.name" placeholder="Ingrese un nombre" />
                </n-form-item>
            </div>

            <div class="mb-3">
                <n-form-item label="Contacto" path="contact">
                <n-input type="text" id="inputContact" v-model:value="contact" placeholder="Ingrese un contacto" />
                </n-form-item>
            </div>

            <div class="mb-3">
                <n-form-item label="Ubicación" path="location">
                <n-input type="text" id="inputLocation" v-model:value="location" placeholder="Ingrese una ubicación" />
                </n-form-item>

            </div>

            <div class="mb-3">
                <n-form-item label="Email" path="email">
                <n-input type="email" id="inputEmail" v-model:value="email" placeholder="Ingrese un correo electrónico" />
                </n-form-item>
            </div>

            <div class="mb-3">
                <n-form-item label="Teléfono" path="phone">
                <n-input id="inputPhone" :show-button='false' v-model:value="phone" placeholder="Ingrese un número de teléfono"
                    class="w-100" />
                </n-form-item>
            </div>
            <div class="mb-3">
                <n-form-item label="Tipo de proveedor:" path="type">
                <n-checkbox-group v-model:value="model.type">
                    <n-space item-style="display: flex;">
                    <n-checkbox value="fertilizer" label="Fertilizantes" />
                    <n-checkbox value="phytosanitary" label="Fitosanitarios" />
                    <n-checkbox value="fertilizerAndPhytosanitary" label="Fertilizantes + Fitosanitarios" />
                    <n-checkbox value="additive" label="Aditivos" />
                    <n-checkbox value="gasoil" label="Gasoil" />
                    <n-checkbox value="seed" label="Semillas" />
                    </n-space>
                </n-checkbox-group>
                </n-form-item>
            </div>

            <div class="mb-3">
                <n-form-item label="Notas (Opcional)" path="extra" style="flex-wrap: wrap">
                <div class="container">
                    <div v-for="(input, index) in extra" :key="`extra-${index}`"
                    class="input wrapper d-flex flex-row items-center w-100">
                    <n-input type="text" id="inputExtra" v-model:value="input.extra" class="h-10 rounded-lg outline-none p-2"
                        placeholder="Ingrese una nota" />
                    <n-button @click="addField(input)" v-show="index == extra.length - 1" style="padding: 15px; margin: 10px">
                        <i class="icon-plus" style="padding: 12px;"></i>
                    </n-button>
                    <n-button @click="removeField(index)" v-show="extra.length > 1" style="padding: 15px; margin: 10px;">
                        <i class="icon-remove" style="padding: 12px;"></i>
                    </n-button>
                    </div>
                </div>
                </n-form-item>
            </div>

            <div class="d-flex justify-content-center">
                <n-button type="info" class="text-center w-100" @click="editProvider" style="font-size: 20px">
                    <i class="icon-edit" style="padding-right: 12px;" />
                    EDITAR PROVEEDOR
                </n-button>
            </div>
        </n-form>
    </div>
</template>

<script>

import { mapActions, mapState } from 'pinia';
import { useMessage } from 'naive-ui';
import providerStore from '../../store/provider'
import authStore from '../../store/auth';

export default {
    data() {
        return {
            formRef: null,
            model: {
                name: null,
                type: null,        
            },
            rules: {
                name: {
                validator: this.validateName,
                required: true,
                trigger: "blur",
                },
                type: {
                    type: "array",
                    required: true,
                    trigger: "blur",
                    message: "Por favor ingrese al menos un tipo"
                }
            },
            contact: null,
            location: null,
            email: null,
            phone: null,
            extra: [{ extra: '' }],
            message: useMessage(),
            isTheFormValid: true,
            providersNames: [],
        }
    },
    async created() {
        await this.getProvidersById(this.$route.params.id)
        this.provider = this.selectedProvider

        this.model.type = this.selectedProvider.type;
        this.model.name = this.selectedProvider.name;
        this.contact = this.selectedProvider.contact;
        this.location = this.selectedProvider.location;
        this.email = this.selectedProvider.email;
        this.phone = this.selectedProvider.phone;
        this.extra = this.selectedProvider.extra;
        if (!this.provider.extra.length){
            //the problem was what when we brought this object,
            //this.provider.extra = [] and we needed an object inside of it.
            this.provider.extra.push({ extra: '' })
        }

    },
    async mounted() {
        if (!this.isLoggedIn) {
            this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
            this.$router.push('/app/login');
        }
        let data = await this.getNames();
        this.providersNames = data.filter((provider) => provider.name != this.model.name)

    },
    computed: {
        ...mapState(providerStore, ['selectedProvider', 'getNames']),
        ...mapState(authStore, ['isLoggedIn'])
    },
    methods: {
        addField() {
            if (!this.selectedProvider.extra.some((item) => item.extra == '')){
                this.selectedProvider.extra.push({ extra: "" });
            }
        },
        removeField(index) {
            this.selectedProvider.extra.splice(index, 1);
        },
        ...mapActions(providerStore, ['getProvidersById', 'updateProvider']),
        validateName(rule, value){
        const nameAlreadyExists = (input, names) =>{
            for (let provider of names){
            if (provider.name?.toLowerCase() == input.toLowerCase()){
                return true;
            } else return false;
            }

        }
        if (!value){
            rule.message = 'Por favor ingrese un nombre';
            return false;
        } else {
            if(nameAlreadyExists(value, this.providersNames)){
                rule.message = 'Ese nombre ya existe';
                return false;
            } else return true
        }
        },
        validateForm(){
            this.$refs.formRef.validate();
            const extraInputCounter = () =>{
                let counter = 0;
                for (let i = 0; i < this.extra.length; i++){
                    if (this.extra[i].extra == ''){
                        counter ++
                    }
                }
                return counter
            }
            if (!this.model.name) {
                this.message.error("Por favor ingrese un nombre");
                this.isTheFormValid = false;
            }

            this.providersNames.forEach((provider)=>{
                if (provider.name.toLowerCase() === this.model.name.toLowerCase()){
                this.message.error('Ese nombre ya existe');
                this.isTheFormValid = false;
                }
            })

            if (this.email){
                let regex = new RegExp('[A-Za-z0-9]+@[A-Za-z0-9]+\.[A-Za-z]{2,3}');
                if (!regex.test(this.email)){
                    this.message.error("Por favor ingrese un correo electrónico válido");
                    this.isTheFormValid = false;;
                }
            }
            if (!this.model.type.length) {
                this.message.error("Por favor ingrese un tipo de proveedor");
                this.isTheFormValid = false;
            }
            if (extraInputCounter() > 1){
                this.message.info("Hay items vacíos en el formulario")
                this.isTheFormValid = false;
            }
        },
        async editProvider() {
            this.validateForm();
            try {
                if (this.isTheFormValid){
                    let data = {
                        name: this.model.name,
                        contact: this.contact,
                        location: this.location,
                        email: this.email,
                        phone: this.phone,
                        extra: [...this.extra],
                        type: this.model.type
                    }
    
                    let extraArray = data.extra;
    
                    for (let i = 0; i < extraArray.length; i++){
                            if (extraArray[i].extra == ''){
                            extraArray.splice(i, 1)
                            i--
                        }
                    }
    
                    await this.updateProvider(this.$route.params.id, data);
                    this.message.success("Proveedor editado");
                    this.$router.push("/app/providers/list");
                }
                this.isTheFormValid = true;
            } catch (err) {
                console.error(err)
                this.message.error("Error al editar proveedor");
            }
        }
    },
}

</script>

